// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignRightOutlinedSvg from "@fishx/icons-svg/es/asn/AlignRightOutlined";
import FishxIcon from '../components/FishxIcon';

var AlignRightOutlined = function AlignRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignRightOutlinedSvg
  }));
};

AlignRightOutlined.displayName = 'AlignRightOutlined';
export default React.forwardRef(AlignRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlignRightOutlined.js
// module id = 1957
// module chunks = 0